<template>
  <v-list dense>
    <v-list-item-group v-model="selectedRange" color="primary">
      <v-list-item
        v-for="(range, key) in filteredRanges"
        :key="key"
        :value="key"
      >
        <v-list-item-title>
          {{ locale.ranges[key] || key }}
        </v-list-item-title>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { reduce } from "lodash";
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    maxRange: {
      type: Number,
      default: null
    },
    ranges: {
      type: Object,
      default: () => ({})
    },
    locale: {
      type: Object,
      default: () => ({
        ranges: {}
      })
    }
  },
  computed: {
    filteredRanges() {
      const { maxRange, ranges } = this;
      if (!maxRange) return ranges;
      return reduce(
        ranges,
        (result, range, key) => {
          if (maxRange >= range().length("days")) result[key] = range;
          return result;
        },
        {}
      );
    },
    selectedRange: {
      get() {
        return this.value;
      },
      set(range) {
        this.$emit("input", range);
      }
    }
  },
  watch: {
    selectedRange(v, ov) {
      if (v != ov) this.selectedRange === v;
    }
  }
};
</script>
